var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0011 0C29.2612 0 35.2012 5.94001 35.2012 13.2C35.2012 20.46 22.0011 37.4001 22.0011 37.4001C22.0011 37.4001 8.80111 20.46 8.80111 13.2C8.80111 5.94001 14.7411 0 22.0011 0ZM22.0011 17.6C24.4211 17.6 26.4012 15.62 26.4012 13.2C26.4012 10.78 24.4211 8.80002 22.0011 8.80002C19.5811 8.80002 17.6011 10.78 17.6011 13.2C17.6011 15.62 19.5811 17.6 22.0011 17.6Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13992 24.42C8.79992 25.74 9.45992 27.06 10.3399 28.38C6.59992 29.7 4.39991 31.46 4.39991 33C4.39991 35.6401 11.4399 39.6001 22 39.6001C32.56 39.6001 39.6 35.6401 39.6 33C39.6 31.46 37.4 29.7 33.66 28.16C34.54 26.84 35.2 25.52 35.86 24.2C40.92 26.4 44 29.48 44 33C44 39.1601 34.76 44.0001 22.44 44.0001C11.4399 44.0001 -9.53674e-05 40.2601 -9.53674e-05 33C-9.53674e-05 29.48 3.07991 26.4 8.13992 24.42Z",
    fill: "#909CBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.7f6a4282b95463376300f323582d9486.svg";
export { ForwardRef as ReactComponent };